import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { createGlobalStyle } from "styled-components";

import { useApi } from "../../../../hooks/api/useApi";
import { useThemeChange } from "../../../../utils/themeChange";
import useAuthStore from "../../../../store/authStore";
// import { ROUTE_ROLES } from "../../../../constants/app-constants";

import { ListArt } from "../../Art";
import Button from "../../../../components/components/Button/Button";
// import { ListCollection } from "../../Collection";

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
 
`;

// const { ARTIST } = ROUTE_ROLES;

const Profile = () => {
  const { getAll } = useApi();
  const navigate = useNavigate();
  const themeChange = useThemeChange();
  const { user } = useAuthStore((state) => ({
    user: state.userLog,
  }));

  // const [showArt, setShowArt] = useState(false);
  // const [showCollection, setShowCollection] = useState(true);

  const artistArts = useQuery({
    queryKey: ["artistArts"],
    queryFn: () => getAll(`arts/artist/${user?.artist?.id}`),
  });

  // const artistCollections = useQuery({
  //   queryKey: ["artistCollections"],
  //   queryFn: () => getAll(`collections/artist/${user?.artist?.id}`),
  // });

  // const handleMyArt = async () => {
  //   if (showCollection) setShowCollection(!showCollection);
  //   setShowArt(!showArt);
  // };
  // const handleMyCollection = () => {
  //   setShowCollection(!showCollection);
  //   if (showArt) setShowArt(!showArt);
  // };

  return (
    <div className={themeChange.add("section")}>
      <GlobalStyles />

      <section className="container no-bottom">
        <div className="spacer-double"></div>

        <div className="d-flex flex-wrap align-items-center justify-content-between">
          <div className="profile_avatar">
            {user?.profileImage ? (
              <img src={user.profileImage} alt="profile-img" />
            ) : (
              <div className="d_profile_img">
                <img src="/img/author/dummy_author.png" alt="" />
              </div>
            )}

            <div className="profile_name">
              <h4>
                {user?.firstName.concat(" ", user?.lastName) || "-"}
                {user?.email && (
                  <span className="profile_username">
                    {user?.email || "Email not registered"}
                  </span>
                )}
              </h4>
            </div>
          </div>
        </div>
      </section>
      <div className="spacer-double"></div>

      {/* {user && user?.roles.includes(ARTIST) && (
        <section className="container no-top">
          <div className="d-flex align-items-center justify-content-between">
            <ul className="de_nav text-left">
              <li id="OwnedCollection" className="active">
                <span
                  className={showCollection ? "custom-border-color" : ""}
                  onClick={handleMyCollection}
                >
                  My Collection
                </span>
              </li>
              <li id="OwnedArt" className="active">
                <span
                  className={showArt ? "custom-border-color" : ""}
                  onClick={handleMyArt}
                >
                  My Arts
                </span>
              </li>
            </ul>
          </div>
          {showArt && <ListArt artistArts={artistArts?.data} />}
          {showCollection && (
            <ListCollection artistCollections={artistCollections?.data} />
          )}
        </section>
      )} */}
      <section className="container no-top">
        <div className="d-flex justify-content-end mb-2">
          <Button
            children="Create Licensing Opportunity"
            onClick={() => navigate("/list-license")}
          />
        </div>
        <h3>Licensing Opportunities</h3>
        <ListArt arts={artistArts?.data} />
      </section>
    </div>
  );
};

export default Profile;
